export default "/images/828782e7a926a5de21ec21689a625374.avif";